var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 6.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8327 14L23.986 10.745L24.3827 6.44L20.171 5.48333L17.966 1.75L13.9993 3.45333L10.0327 1.75L7.82768 5.47167L3.61602 6.41667L4.01268 10.7333L1.16602 14L4.01268 17.255L3.61602 21.5717L7.82768 22.5283L10.0327 26.25L13.9993 24.535L17.966 26.2383L20.171 22.5167L24.3827 21.56L23.986 17.255L26.8327 14ZM10.9427 18.6783L8.16601 15.8783C8.05786 15.7704 7.97205 15.6422 7.91351 15.5011C7.85497 15.3599 7.82483 15.2086 7.82483 15.0558C7.82483 14.903 7.85497 14.7517 7.91351 14.6106C7.97205 14.4695 8.05786 14.3413 8.16601 14.2333L8.24768 14.1517C8.70268 13.6967 9.44935 13.6967 9.90435 14.1517L11.7827 16.0417L17.791 10.0217C18.246 9.56667 18.9927 9.56667 19.4477 10.0217L19.5293 10.1033C19.9843 10.5583 19.9843 11.2933 19.5293 11.7483L12.6227 18.6783C12.1443 19.1333 11.4093 19.1333 10.9427 18.6783Z",
    fill: "#147BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerified);
export default __webpack_public_path__ + "static/media/icon-verified.ea81c24bb5a6da86553af5f6295ec6d4.svg";
export { ForwardRef as ReactComponent };